<template>
  <section
    id="jdih"
    class="infografis-anchor-section jdih-section tab-panel">
    <div class="section-top mb-5">
      <div class="section-top__left">
        <div class="section-chip">⚖️ Modul JDIH</div>
        <p class="section-lead mb-0 mt-3">
          Menampilkan ringkasan jumlah produk hukum, status, serta persebaran bidang berdasarkan tahun yang dipilih.
        </p>
      </div>
      <div class="filters">
        <div class="filter-item filter-item--year">
          <label for="jdihYear">Tahun</label>
          <v-autocomplete
            :value="selectedYear"
            :items="yearOptions"
            dense
            placeholder="Pilih Tahun"
            single-line
            outlined
            hide-details
            class="filter-input"
            @change="$emit('update:year', $event)" />
        </div>
      </div>
    </div>

    <!-- <v-card
      flat
      class="jdih-shell">
      <div class="jdih-shell__body"> -->
        <!-- <header class="jdih-shell__intro mb-4">
          <div class="text-h6 font-weight-bold">
            Grafik Produk Hukum berdasarkan data JDIH Kabupaten Klaten
          </div>
          <div class="text-caption text--secondary mt-1">
            Tahun acuan {{ selectedYear }}
          </div>
        </header> -->
        <JdihCharts
          :selected-year="selectedYear"
          :chart-height-jdih="chartHeightJdih"
          :jdih-loading="jdihLoading"
          :jdih-error="jdihError"
          :jdih-has-chart-data="jdihHasChartData"
          :jdih-chart-options="jdihChartOptions"
          :jdih-chart-series="jdihChartSeries"
          :jdih-summary-total="jdihSummaryTotal"
          :jdih-summary-top-label="jdihSummaryTopLabel"
          :jdih-status-summary-total="jdihStatusSummaryTotal"
          :jdih-status-summary-top-label="jdihStatusSummaryTopLabel"
          :jdih-status-loading="jdihStatusLoading"
          :jdih-status-error="jdihStatusError"
          :jdih-status-has-chart-data="jdihStatusHasChartData"
          :jdih-status-chart-options="jdihStatusChartOptions"
          :jdih-status-chart-series="jdihStatusChartSeries"
          :jdih-bidang-loading="jdihBidangLoading"
          :jdih-bidang-error="jdihBidangError"
          :jdih-bidang-has-chart-data="jdihBidangHasChartData"
          :jdih-bidang-chart-options="jdihBidangChartOptions"
          :jdih-bidang-chart-series="jdihBidangChartSeries"
          :jdih-bidang-summary-total="jdihBidangSummaryTotal"
          :jdih-bidang-summary-top-label="jdihBidangSummaryTopLabel" />
      <!-- </div>
    </v-card> -->
  </section>
</template>

<script>
import JdihCharts from '@/components/infografis/JdihCharts.vue'

export default {
  name: 'JdihSection',
  components: {
    JdihCharts
  },
  props: {
    selectedYear: {
      type: Number,
      required: true
    },
    yearOptions: {
      type: Array,
      default: () => []
    },
    chartHeightJdih: {
      type: Number,
      required: true
    },
    jdihLoading: {
      type: Boolean,
      default: false
    },
    jdihError: {
      type: String,
      default: ''
    },
    jdihHasChartData: {
      type: Boolean,
      default: false
    },
    jdihChartOptions: {
      type: Object,
      required: true
    },
    jdihChartSeries: {
      type: Array,
      default: () => []
    },
    jdihSummaryTotal: {
      type: Number,
      default: 0
    },
    jdihSummaryTopLabel: {
      type: String,
      default: ''
    },
    jdihStatusSummaryTotal: {
      type: Number,
      default: 0
    },
    jdihStatusSummaryTopLabel: {
      type: String,
      default: ''
    },
    jdihStatusLoading: {
      type: Boolean,
      default: false
    },
    jdihStatusError: {
      type: String,
      default: ''
    },
    jdihStatusHasChartData: {
      type: Boolean,
      default: false
    },
    jdihStatusChartOptions: {
      type: Object,
      required: true
    },
    jdihStatusChartSeries: {
      type: Array,
      default: () => []
    },
    jdihBidangLoading: {
      type: Boolean,
      default: false
    },
    jdihBidangError: {
      type: String,
      default: ''
    },
    jdihBidangHasChartData: {
      type: Boolean,
      default: false
    },
    jdihBidangChartOptions: {
      type: Object,
      required: true
    },
    jdihBidangChartSeries: {
      type: Array,
      default: () => []
    },
    jdihBidangSummaryTotal: {
      type: Number,
      default: 0
    },
    jdihBidangSummaryTopLabel: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.infografis-anchor-section {
  scroll-margin-top: 52px;
}

@media (min-width: 600px) {
  .infografis-anchor-section {
    scroll-margin-top: 68px;
  }
}

@media (min-width: 960px) {
  .infografis-anchor-section {
    scroll-margin-top: 104px;
  }
}

.jdih-section {
  max-width: 100%;
}

.jdih-shell {
  border-radius: 24px !important;
  border: 1px solid rgba(21, 73, 135, 0.12) !important;
  box-shadow: none !important;
  background: #ffffff !important;
  overflow: visible !important;
}

.tab-panel {
  padding: 22px;
}

.section-top {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 16px;
  flex-wrap: wrap;
}

.section-top__left {
  flex: 1 1 640px;
  min-width: 320px;
}

.section-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 800;
  color: #1757b8;
  background: rgba(23, 87, 184, 0.08);
  border: 1px solid rgba(23, 87, 184, 0.08);
  border-radius: 999px;
  padding: 8px 12px;
}

.section-lead {
  color: #6f7f92;
  font-size: 14px;
  line-height: 1.6;
  max-width: 850px;
}

.filters {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: nowrap;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}

.filter-item {
  flex: 0 0 auto;
}

.filter-item--year {
  width: 124px;
}

.filter-item label {
  display: block;
  margin-bottom: 7px;
  font-size: 12px;
  color: #7d8ea4;
  font-weight: 600;
}

.filter-input::v-deep .v-input__slot {
  border-radius: 14px !important;
  min-height: 36px !important;
  border-color: rgba(22, 50, 79, 0.16) !important;
}

.filter-input::v-deep .v-input__append-inner {
  margin-top: 6px;
}

.filter-input::v-deep .v-input__control {
  min-height: 36px;
}

.filter-input::v-deep input {
  font-size: 13px;
}

.jdih-shell__body {
  padding: 18px;
}

@media (max-width: 720px) {
  .tab-panel {
    padding: 16px;
  }

  .filters {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .section-top__left {
    flex: 1 1 100%;
    min-width: 0;
  }

  .filter-item {
    flex: 1 1 100%;
    min-width: 0;
  }

  .filter-item--year {
    width: 100%;
  }
}
</style>
